import {
  ActionButton,
  Depths,
  Icon,
  Label,
  mergeStyleSets,
} from "@fluentui/react";
import { useState } from "react";
import { IPaginacion } from "../../Interfaces/filter";

interface IPaginationFooterC {
  paginacion: IPaginacion;
  onChangePagina: (event: string) => void;
}

export const PaginationFooterC = (props: IPaginationFooterC) => {
  const classes = mergeStyleSets({
    navigationText: {
      width: "auto",
      margin: "0 0px",
      fontSize: "12px",
    },
    icon: {
      fontSize: "15px",
      height: "15px",
      padding: "0px 10px",
    },
    iconVertical: {
      color: "#0078d4",
      margin: "0px",
    },
  });

  return (
    <Label
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#f3f2f1",
        height: "30px",
        boxShadow: Depths.depth8,
      }}
    >
      <div
        key={"izquierda"}
        style={{
          display: "flex",
          alignItems: "center",
          height: "30px",
        }}
      >
        <span className={classes.navigationText}> Total de Registros </span>
        <Icon className={classes.iconVertical} iconName="Separator" />
        <span className={classes.navigationText}>
          {" "}
          {props.paginacion?.total ? props.paginacion?.total : "_ _"}{" "}
        </span>
      </div>
      <div
        key={"derecha"}
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <ActionButton
          disabled={props.paginacion?.page + 1 === 1}
          className={classes.icon}
          iconProps={{ iconName: "ChevronLeftMed" }}
          onClick={() => props.onChangePagina("prev")}
        />
        <span className={classes.navigationText}>
          Página {props.paginacion?.page + 1} de{" "}
          {props.paginacion?.pages ? props.paginacion?.pages : "_ _"}
        </span>
        <ActionButton
          disabled={props.paginacion?.page + 1 === props.paginacion?.pages}
          className={classes.icon}
          iconProps={{ iconName: "ChevronRightMed" }}
          onClick={() => props.onChangePagina("next")}
        />
      </div>
    </Label>
  );
};
